import React from 'react';

import {
  Grid,
  makeStyles,
  Popover,
  IconButton,
  InfoOutlinedIcon,
} from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    width: ({ width }) => width,
    overflow: 'hidden',
    padding: '8px',
  },
}));

const InfoPopover = ({ children, width = '160px' }) => {
  const classes = useStyles({ width });

  return (
    <Popover
      hover
      anchor={<IconButton icon={<InfoOutlinedIcon />} fontSize={'small'} />}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <div className={classes.root}>
        <Grid container>{children}</Grid>
      </div>
    </Popover>
  );
};

export default InfoPopover;
